import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { patronEventsResolver } from './events/data-access/events.service';

// test
const routes: Routes = [
  {
    path: '',
    redirectTo: 'events',
    pathMatch: 'full',
  },
  {
    path: 'events',
    resolve: { resolvedPatronEvents: patronEventsResolver },
    loadChildren: () => import('./events/events.routing.module').then(m => m.EventsRoutingModule),
  },
  {
    path: 'seat-selection',
    loadChildren: () =>
      import('./seat-selection/seat-selection.routing.module').then(m => m.SeatSelectionRoutingModule),
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.routing.module').then(m => m.CheckoutRoutingModule),
  },
  {
    path: 'payment',
    loadChildren: () => import('./payment/payment.routing.module').then(m => m.PaymentRoutingModule),
  },
  {
    path: 'summary',
    loadChildren: () => import('./summary/summary.routing.module').then(m => m.SummaryRoutingModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
